var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component"},'component',_vm.attr,false),[_c('div',{staticClass:"htmlContent",domProps:{"innerHTML":_vm._s(_vm.$dompurify(_vm.htmlContent))}})])}
var staticRenderFns = []

export { render, staticRenderFns }